<template>
  <section>
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
      tag="div"
    >
      <form @submit.prevent="submit">
        <div class="support-form">
          <input-form
            v-model="subject"
            :title="$t('question.subject')"
            name="subject"
            :placeholder="$t('question.subjectPlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            rules="required"
            maxlength="50"
          />

          <input-form
            id="name"
            ref="name"
            v-model="name"
            :title="$t('question.name')"
            name="name"
            :placeholder="$t('question.namePlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            rules="required"
            maxlength="50"
          />

          <input-form
            id="offer"
            ref="offer"
            v-model="offer"
            :title="$t('question.organization')"
            name="offer"
            :placeholder="$t('question.organizationPlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            rules="required"
            maxlength="50"
          />

          <input-form
            id="mail"
            ref="mail"
            v-model="mail"
            :title="$t('question.email')"
            name="mail"
            :placeholder="$t('question.emailPlaceholder')"
            type="email"
            autocomplete="off"
            required="required"
            rules="required"
            maxlength="50"
          />

          <input-form
            id="textarea"
            ref="textarea"
            v-model="textarea"
            :title="$t('question.detail')"
            name="textarea"
            :placeholder="$t('question.detailPlaceholder')"
            type="textarea"
            autocomplete="off"
            required="required"
            maxlength="500"
          />

          <input-form
            id="file"
            v-model="file"
            :title="$t('question.attachFile')"
            :placeholder="$t('question.attachFilePlaceholder')"
            type="file"
            :is-upload="attachFileId !== null"
            :loading="fileLoading"
            :error-message="fileError"
            @input="attachUpload"
            @change:delete="onDeleteFile"
          >
            <small>{{ $t('question.attachFileNote') }}</small>
          </input-form>
        </div>

        <div class="support-agree">
          <div class="agree-check-all">
            <check-box
              id="all"
              v-model="agreeAll"
              :text="$t('question.agreeAll')"
              name="agree-all"
              @input="onChangeAgreeAll($event)"
            />
          </div>
          <div class="agree-wrap">
            <div class="agree-title">{{ $t('question.privateTitle') }}</div>
            <div class="agree-content">
              <div class="agree-check">
                <check-box
                  id="private"
                  ref="private"
                  v-model="agreePrivate"
                  :text="$t('question.private')"
                  name="agree-private"
                  required
                />
              </div>
              <html-view class="agree-term" :value="$t('question.privateValue')" />
              <!--              <div class="agree-term">-->
              <!--                <p>(주)우아한형제들은 제휴·문의사항 등록 시, 최소한의 범위 내에서 아래와 같이 개인정보를 수집·이용합니다.</p>-->
              <!--                <ol>-->
              <!--                  <li>-->
              <!--                    1. 수집하는 개인정보 항목<br>-->
              <!--                    <table class="agree-term-table">-->
              <!--                      <colgroup>-->
              <!--                        <col style="width: 20%">-->
              <!--                        <col style="width: 40%">-->
              <!--                        <col>-->
              <!--                      </colgroup>-->
              <!--                      <thead>-->
              <!--                        <tr>-->
              <!--                          <th>구분</th>-->
              <!--                          <th>수집하는 개인정보 항목</th>-->
              <!--                          <th>수집 및 이용 목적</th>-->
              <!--                        </tr>-->
              <!--                      </thead>-->
              <!--                      <tbody>-->
              <!--                        <tr>-->
              <!--                          <td>제휴, 제안</td>-->
              <!--                          <td>소속, 이름, 전자우편주소</td>-->
              <!--                          <td>제휴, 제안 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                        <tr>-->
              <!--                          <td>언론홍보문의</td>-->
              <!--                          <td>매체명, 이름, 전자우편주소</td>-->
              <!--                          <td>언론홍보문의 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                        <tr>-->
              <!--                          <td>지원문의</td>-->
              <!--                          <td>이름, 전자우편주소</td>-->
              <!--                          <td>지원문의 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                        <tr>-->
              <!--                          <td>광고신청문의</td>-->
              <!--                          <td>이름, 업소명, 업소주소, 연락처, 전자우편주소</td>-->
              <!--                          <td>광고신청문의 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                        <tr>-->
              <!--                          <td>기타문의</td>-->
              <!--                          <td>이름, 전자우편주소</td>-->
              <!--                          <td>기타문의 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                      </tbody>-->
              <!--                    </table>-->
              <!--                  </li>-->
              <!--                  <li>2. 수집 및 이용 목적: 제휴·문의사항 접수 및 처리결과 회신</li>-->
              <!--                  <li>3. 개인정보의 이용기간: <span>목적 달성 후, 해당 개인정보를 지체없이 파기</span></li>-->
              <!--                </ol>-->
              <!--                <br>-->
              <!--                <p>위 개인정보 수집‧이용에 대한 동의를 거부할 권리가 있습니다. 다만 동의를 거부하는 경우 제휴·문의사항 등록이 제한될 수 있습니다.</p>-->
              <!--              </div>-->
            </div>
          </div>
          <div class="agree-wrap">
            <div class="agree-title">유의사항 안내</div>
            <div class="agree-content">
              <div class="agree-check">
                <check-box
                  id="precautions"
                  ref="precautions"
                  v-model="agreePrecautions"
                  :text="$t('question.precautions')"
                  name="precautions"
                  required
                />
              </div>
              <html-view class="agree-term" :value="$t('question.precautionValue')" />
              <!--              <div class="agree-term">-->
              <!--                <p>-->
              <!--                  제안자의 제휴 및 제안 내용은 이미 배달의민족 내부적으로 진행중인 사업과 유사하거나 동일하거나, 제 3자로부터 먼저 제안이 들어온 내용이거나, 또는 검토 당시의 당사의 사업적 방향이나 제휴-->
              <!--                  조건이 맞지 않는 등의 여러 이유로 거절 될 수 있습니다.-->
              <!--                </p>-->
              <!--                <p>따라서 당사에 공개 가능한 정보만 기재하여 주시기 바라며, 당사는 제휴제안 거절에 대해 제안자에 대한 보상, 회신 등 어떠한 의무도 부담하지 않는 점 양해 부탁드립니다.</p>-->
              <!--                <p>-->
              <!--                  제휴제안서에는 제안자의 영업비밀이나 기밀사항, 보호가 필요하다고 생각하는 사업적 아이디어 등을 제외하고 기재하여 주시기 바랍니다.<br>-->
              <!--                  아울러, 특허 및 디자인, 저작권 등 각종 지식재산권의 공개 내지 공유가 필요한 제휴 요청의 경우, 반드시 출원 등 제안자의 권리 보호를 위해 필요한 조치를 마치신 후에 제휴제안을 요청하여-->
              <!--                  주시기 바랍니다.-->
              <!--                </p>-->
              <!--              </div>-->
            </div>
          </div>
        </div>

        <div class="support-btn">
          <button type="submit" class="btn btn-fill btn-wide" :disabled="invalid">{{ $t('question.submit') }}</button>
        </div>
      </form>
    </validation-observer>
  </section>
</template>
<script>
import supportForm from '@/mixins/supportForm'

export default {
  mixins: [supportForm],
  data () {
    return {
      agreePrecautions: false,
    }
  },
  watch: {
    agreePrivate (v) {
      if (!v) this.agreeAll = false
      if (v && this.agreePrecautions) {
        this.agreeAll = true
      }
    },
    agreePrecautions (v) {
      if (!v) this.agreeAll = false
      if (v && this.agreePrivate) {
        this.agreeAll = true
      }
    }
  },
  methods: {
    submit () {
      this.saveQuestion({
        company: this.offer,
        content: this.textarea,
        email: this.mail,
        name: this.name,
        title: this.subject,
        type: 'OFFER'
      })
    },
    onChangeAgreeAll (v) {
      if (v) {
        this.agreePrivate = true
        this.agreePrecautions = true
      } else {
        this.agreePrivate = false
        this.agreePrecautions = false
      }
    }
  }
}
</script>
